import GiftRedemptionTable from "./giftRedemptionTable.container"

export default GiftRedemptionTable
